import { useState } from 'react';
import classes from './VideoGallery.module.scss';

const extractYoutubeId = (urlOrId) => {
    try {
        const url = new URL(urlOrId);
        return url.searchParams.get('v') ?? url.pathname.split('/').pop();
    } catch {
        return urlOrId;
    }
};

const VideoGallery = ({ videos }) => {
    const [activeVideo, setActiveVideo] = useState(videos[0]);
    const activeId = extractYoutubeId(activeVideo?.url);

    return (
        <div className={classes.Gallery}>
            <div className={classes.MainPlayer}>
                {activeId ? (
                    <iframe
                        key={activeId}
                        className={classes.Iframe}
                        src={`https://www.youtube.com/embed/${activeId}?autoplay=1&mute=1&rel=0&modestbranding=1`}
                        title={activeVideo?.title}
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        referrerPolicy="strict-origin-when-cross-origin"
                        allowFullScreen
                    />
                ) : null}
            </div>
            <ul className={classes.Thumbnails}>
                {videos.map((video) => {
                    const videoId = extractYoutubeId(video.url);
                    return (
                        <li key={video.url}>
                            <button
                                className={`${classes.Thumb} ${video.url === activeVideo?.url ? classes.ThumbActive : ''}`}
                                onClick={() => setActiveVideo(video)}
                                aria-label={video.title}
                                aria-pressed={videoId === activeId}
                            >
                                <img
                                    src={`https://img.youtube.com/vi/${videoId}/mqdefault.jpg`}
                                    alt={video.title}
                                    className={classes.ThumbImg}
                                />
                            </button>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};

export default VideoGallery;
